import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'msisdnFormatClear'})
export default class MsisdnFormatClear implements PipeTransform {
  transform(msisdn: string): string {
    if (!msisdn) {
      return msisdn;
    }

    return msisdn.replace(/(\+48)?(\s)*/ig, '');
  }
}
